export class TargetZone {
    /**
     * Index zonu
     */
    id: number;
    /**
     * Vnitrni polomer zony jako pomer vuci polomeru terce. Cele cislo v rozsahu 0 az 100
     */
    innerRadiusRatio: number;
    /**
     * Vnejsi polomer zony jako pomer vuci polomeru terce. Cele cislo v rozsahu 0 az 100
     */
    outerRadiusRatio: number;
    /**
     * Score za zasazeni zony u vnitrniho okraje
     */
    innerRadiusScore: number;
    /**
     * Score za zasazeni zony u vnejsiho okraje
     */
    outerRadiusScore: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(id: number, innerRadiusRatio: number, outerRadiusRatio: number, innerRadiusScore: number, outerRadiusScore: number) {
        this.id = id;
        this.innerRadiusRatio = innerRadiusRatio;
        this.innerRadiusScore = innerRadiusScore;
        this.outerRadiusRatio = outerRadiusRatio;
        this.outerRadiusScore = outerRadiusScore;
    }

    //-------------------------------------------------------------------------
    /**
     * Ziskat skore 
     * @param radiusRatio Polomer zasahu jako pomer vuci polomeru terce. Musi byt v rozsahu innerRadiusRatio -> outerRadiusRatio a jedna se o cele cislo v rozsahu 0 az 100
     * @returns 
     */
    //-------------------------------------------------------------------------
    getScore(radiusRatio: number): number {
        return Math.round(this.innerRadiusScore + (this.outerRadiusScore - this.innerRadiusScore) * ((radiusRatio - this.innerRadiusRatio) / (this.outerRadiusRatio - this.innerRadiusRatio)));
    }
}